// GLTFLoader parses packaged binary models with TextDecoder; Mini Games have no DOM.
if (typeof globalThis.TextDecoder === 'undefined') {
  globalThis.TextDecoder = class Utf8Decoder {
    constructor(label = 'utf-8', options = {}) {
      if (!['utf-8', 'utf8'].includes(String(label).toLowerCase())) throw new RangeError('Only UTF-8 decoding is supported');
      this.encoding = 'utf-8'; this.fatal = !!options.fatal; this.ignoreBOM = !!options.ignoreBOM;
    }
    decode(input = new Uint8Array()) {
      const bytes = ArrayBuffer.isView(input) ? new Uint8Array(input.buffer, input.byteOffset, input.byteLength) : new Uint8Array(input);
      let result = '';
      const invalid = () => { if (this.fatal) throw new TypeError('Invalid UTF-8'); return '\ufffd'; };
      for (let index = 0; index < bytes.length;) {
        const first = bytes[index++];
        if (first < 0x80) { result += String.fromCharCode(first); continue; }
        const count = first >= 0xc2 && first <= 0xdf ? 1 : first <= 0xef && first >= 0xe0 ? 2 : first >= 0xf0 && first <= 0xf4 ? 3 : 0;
        if (!count) { result += invalid(); continue; }
        let code = first & (0x7f >> (count + 1));
        let valid = index + count <= bytes.length;
        for (let offset = 0; valid && offset < count; offset++) {
          const byte = bytes[index + offset];
          if ((byte & 0xc0) !== 0x80 || (offset === 0 && ((first === 0xe0 && byte < 0xa0) || (first === 0xed && byte >= 0xa0) || (first === 0xf0 && byte < 0x90) || (first === 0xf4 && byte >= 0x90)))) valid = false;
          else code = (code << 6) | (byte & 0x3f);
        }
        if (!valid) { result += invalid(); continue; }
        index += count;
        result += String.fromCodePoint(code);
      }
      return !this.ignoreBOM && result.charCodeAt(0) === 0xfeff ? result.slice(1) : result;
    }
  };
}

if (typeof globalThis.performance === 'undefined') {
  const origin = Date.now();
  let last = 0;
  let native;
  try { native = globalThis.wx?.getPerformance?.(); } catch {}
  // wx Performance uses microseconds; Three and browser animation use milliseconds.
  globalThis.performance = { now() { last = Math.max(last, native ? native.now() / 1000 : Date.now() - origin); return last; } };
}

if (typeof globalThis.AbortController === 'undefined') {
  class MiniAbortSignal {
    constructor() { this.aborted = false; this.reason = undefined; this.listeners = []; }
    addEventListener(type, listener) { if (type === 'abort') this.listeners.push(listener); }
    removeEventListener(type, listener) {
      if (type === 'abort') this.listeners = this.listeners.filter((item) => item !== listener);
    }
    dispatchEvent(event) { this.listeners.slice().forEach((listener) => listener.call(this, event)); }
    static any(signals) {
      const controller = new MiniAbortController();
      for (const signal of signals) {
        if (signal.aborted) { controller.abort(signal.reason); break; }
        signal.addEventListener('abort', () => controller.abort(signal.reason));
      }
      return controller.signal;
    }
  }
  class MiniAbortController {
    constructor() { this.signal = new MiniAbortSignal(); }
    abort(reason = new Error('Aborted')) {
      if (this.signal.aborted) return;
      this.signal.aborted = true;
      this.signal.reason = reason;
      this.signal.dispatchEvent({ type: 'abort', target: this.signal });
    }
  }
  globalThis.AbortSignal = MiniAbortSignal;
  globalThis.AbortController = MiniAbortController;
}
